import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";

import { DeleteImageBirthdayParams } from "core/http/service/accountInfo/paramsTypes";

interface InitialState {
  status: ReduxStateType;
  data: any;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: {},
};

const deleteImageBirthdaySlice = createSlice({
  name: "deleteImageBirthday",
  initialState,
  reducers: {
    deleteImageBirthdayStart: (
      state,
      action: PayloadAction<DeleteImageBirthdayParams>
    ) => {
      state.status = ReduxStateType.LOADING;
    },
    deleteImageBirthdaySuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    deleteImageBirthdayFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  deleteImageBirthdayStart,
  deleteImageBirthdaySuccess,
  deleteImageBirthdayFailed,
} = deleteImageBirthdaySlice.actions;

export default deleteImageBirthdaySlice.reducer;
